export default "__VITE_ASSET__Cfx80mUK__"